import { render, staticRenderFns } from "./Iframe copy.vue?vue&type=template&id=3418f3d2&scoped=true"
import script from "./Iframe copy.vue?vue&type=script&lang=js"
export * from "./Iframe copy.vue?vue&type=script&lang=js"
import style0 from "./Iframe copy.vue?vue&type=style&index=0&id=3418f3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3418f3d2",
  null
  
)

export default component.exports